<template>
  <div class="ml-8 mr-8">
    <div>
      <v-card-title class="pb-10 pl-0 pr-1">
        <h3 class="headline mb-0 text-h4">{{ $t('label.aprovacao_acao_contrato') }}</h3>
        <v-spacer></v-spacer>
        <v-tooltip bottom content-class="tooltip-tabela-custom">
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              color="grey"
              :size="30"
              v-bind="attrs"
              v-on="on"
              class="mr-2"
              style="cursor:pointer"
            >
              info
            </v-icon>
          </template>
          <div class="tabela-tooltip">
            <table style="border-collapse: collapse; font-size: 14px;">
              <tr>
                <th>ID contrato</th>
                <th>Tipo do Contrato</th>
                <th>ID contrato</th>
                <th>Tipo do Contrato</th>
              </tr>
              <tr>
                <td>3</td>
                <td>ALUGUEL</td>
                <td>4</td>
                <td>BÔNUS VAREJO / HC</td>
              </tr>
              <tr>
                <th>ID ação</th>
                <th>Tipo da Ação</th>
                <th>ID ação</th>
                <th>Tipo da Ação</th>
              </tr>
              <tr>
                <td>77</td>
                <td>TIN - CARÊNCIA</td>
                <td>76</td>
                <td>TIN - BÔNUS EXCEÇÃO</td>
              </tr>
              <tr>
                <td>79</td>
                <td>TIN - ALUGUEL</td>
                <td>75</td>
                <td>TIN - BÔNUS VAREJO HC</td>
              </tr>
            </table>
          </div>
        </v-tooltip>
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn class="rounded-pill" v-on="on" @click="exportarLayout">
              <v-icon class="pr-1">file_download</v-icon>
              {{ $t('label.exportar_layout') }}
            </v-btn>
          </template>
          <span> {{ $t('label.exportar_layout') }}</span>
        </v-tooltip>
      </v-card-title>
    </div>
    <v-card class="card-size rounded-lg">
      <v-row justify="space-between">
        <v-col cols="12" sm="6" md="3" class="ml-3 pb-8">
          <h4 class="headline">{{ $t('label.importacoes') }}</h4>
          <v-text-field
            v-model="search"
            append-icon="search"
            :label="$t('label.pesquisar')"
            single-line
            clearable
            hide-details>
          </v-text-field>
        </v-col>
        <v-col class="pr-6 text-right">
          <v-menu bottom left origin="center center" transition="scale-transition">
            <template v-slot:activator="{ on }">
              <v-btn
                :color="selected.length === 0 ? 'grey' : 'red'"
                :style="selected.length === 0 ? 'pointer-events: none; opacity: 0.5;' : ''"
                dark v-on="on">
                <v-icon class="pr-1">cancel</v-icon>
                {{ $t('label.excluir') }}
                <v-icon right>arrow_drop_down</v-icon>
              </v-btn>
            </template>
            <v-list class="pa-2">
              <v-list-item @click="confirmaExcluirAcoesSelecionadas" link>
                <v-list-item-action>
                  <v-icon>check_box</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                  {{ $t('label.excluir_selecionados') }}
                </v-list-item-content>
              </v-list-item>
              <v-list-item @click="confirmarExclusaoTodos" link>
                <v-list-item-action>
                  <v-icon>cancel</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                  <v-list-item-title>{{ $t('label.excluir_massa') }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-menu>

          <v-menu bottom left origin="center center" transition="scale-transition">
            <template v-slot:activator="{ on }">
              <v-btn
                :color="selected.length === 0 ? 'grey' : 'green'"
                :style="selected.length === 0 ? 'pointer-events: none; opacity: 0.5;' : ''"
                dark class="ml-4" v-on="on">
                <v-icon class="pr-1">add_circle</v-icon>
                {{ $t('label.criar_acao') }}
                <v-icon right>arrow_drop_down</v-icon>
              </v-btn>
            </template>
            <v-list class="pa-2">
              <v-list-item @click="confirmaCriacaoAcoesSelecionadas" link>
                <v-list-item-action>
                  <v-icon>check_box</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                  {{ $t('label.criar_selecionados') }}
                </v-list-item-content>
              </v-list-item>
              <v-list-item @click="confirmaCriarTudo" link>
                <v-list-item-action>
                  <v-icon>library_add</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                  <v-list-item-title>{{ $t('label.criar_massa') }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-menu>

        </v-col>
      </v-row>
      <v-data-table
        v-model="selected"
        show-select
        item-key="id"
        :headers="headers"
        :items="acoesFiltradas"
        :no-data-text="$t('label.tabela_sem_conteudo')">
        <template v-slot:item="{ item, isSelected, select }">
          <tr :key="item.id">
            <td>
              <v-simple-checkbox :value="isSelected" @input="select($event)"></v-simple-checkbox>
            </td>
            <td>{{ item.id }}</td>
            <td>{{ item.nomeTipoContrato }}</td>
            <td>{{ item.nomeTipoAcao }}</td>
            <td>{{ item.numeroContratoAcao }}</td>
            <td>
              {{ item.nomeFocoContrato }}
              <v-tooltip bottom v-if="item.contratoExiste">
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    color="grey"
                    :size="22"
                    v-bind="attrs"
                    v-on="on"
                    class="ml-2"
                  >
                    info
                  </v-icon>
                </template>
                <span>Já existe um contrato de tipo {{ item.nomeTipoContrato }} cadastrado para o {{ item.focoAcao }} {{ item.nomeFocoContrato }}.</span>
              </v-tooltip>
            </td>
            <td>{{ item.codNome }}</td>
            <td>{{ item.notaFiscalAcao }}</td>
            <td>
              <v-menu bottom left origin="center center" transition="scale-transition">
                <template v-slot:activator="{ on }">
                  <v-btn v-on="on" icon @click="visualizarContrato(item)">
                    <v-icon>visibility</v-icon>
                  </v-btn>
                </template>
              </v-menu>
            </td>
          </tr>
        </template>
      </v-data-table>
      <planejamento-contrato-form-acoes-visao
        ref="modalAcao"
        :alterarFinalizado="false"
        :copia="false"
        :edicao="false"
        :novo="true"
        :tipo-contrato="tipoContratoSelecionado ? tipoContratoSelecionado.nome : ''"
        :contrato-edicao="contratoSelecionado"
        :configuracao-contrato="configuracaoSelecionada || {}"
        :novo-contrato="novoContrato"
        :objeto-passo-geral-contrato="objetoPassoGeral"
        :somente-leitura="true"
        :forca-somente-leitura="true"
        :campos-limitadores="[]"
        />
    </v-card>
    <confirm
      ref="confirmaExcluirTudo"
      :message="mensagemAviso"
      :persistent="true"
      @agree="excluirTudo"/>
    <confirm
      ref="confirmaExcluirSelecionados"
      :message="mensagemAviso"
      :persistent="true"
      @agree="excluirSelecionados"/>
    <confirm
      ref="confirmaCriarTudo"
      :message="mensagemAviso"
      :persistent="true"
      @agree="criarTudo"/>
    <confirm
      ref="confirmaCriarSelecionados"
      :message="mensagemAviso"
      :persistent="true"
      @agree="criarSelecionados"/>
    <v-dialog v-model="modalErrosVisivel" max-width="800">
      <v-card>
        <v-card-title>
          <span class="headline">{{ $t('title.erro_criar_acoes') }}</span>
        </v-card-title>
        <v-card-text>
          <v-data-table
            :headers="[{ text: 'ID', value: 'id', sortable: false, width: '20%' }, { text: 'Erro', value: 'mensagem', sortable: false }]"
            :items="listaErros"
            hide-default-footer
            class="elevation-1"
          />
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="black" text @click="modalErrosVisivel = false">{{ $t('label.ok') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex';
import { generateComputed } from '../../../../common/functions/roles-computed-generator';
import Status from '../../../../shared-components/Status';
import Confirm from '../../../../shared-components/vuetify/dialog/Confirm';
import ContratoConfiguracao from '../../ContratoConfiguracao';
import PlanejamentoContratoDialogCancelarAcao from './PlanejamentoContratoDialogCancelarAcao';
import PlanejamentoAcaoFluxoList from '../../../planejamento-acao/PlanejamentoAcaoFluxoList';
import PlanejamentoAcaoFormUsuarioCliente from '../../../planejamento-acao/form/PlanejamentoAcaoFormUsuarioCliente';
import PlanejamentoContratoDialogCancelarAcaoAprovada from './PlanejamentoContratoDialogCancelarAcaoAprovada';
import PlanejamentoContratoFormAcoesApuracoesAgrupadas from './PlanejamentoContratoFormAcoesApuracoesAgrupadas';
import PlanejamentoContratoFormAcoesVisao from './PlanejamentoContratoFormAcoesVisao';
import exportacao from '../../../../common/functions/exportacao';
import errorMessage from '../../../../common/functions/message';

export default {
  name: 'PlanejamentoContratoFormAcoesContratoVisualizacao',
  components: {
    PlanejamentoAcaoFormUsuarioCliente,
    PlanejamentoContratoDialogCancelarAcao,
    PlanejamentoAcaoFluxoList,
    PlanejamentoContratoDialogCancelarAcaoAprovada,
    Status,
    Confirm,
    PlanejamentoContratoFormAcoesApuracoesAgrupadas,
    PlanejamentoContratoFormAcoesVisao,
  },
  computed: {
    acoesFiltradas() {
      if (!this.search) {
        return this.acoesImportadas;
      }
      return this.acoesImportadas.filter((item) => (item.nomeTipoAcao || '')
        .toUpperCase().includes(this.search.toUpperCase()) || (item.id || '').toString()
        .toUpperCase().includes(this.search.toUpperCase()) || (item.nomeTipoContrato || '')
        .toUpperCase().includes(this.search.toUpperCase()) || (item.numeroContratoAcao || '')
        .toUpperCase().includes(this.search.toUpperCase()) || (item.codNome || '')
        .toUpperCase().includes(this.search.toUpperCase()) || (item.nomeFocoContrato || '')
        .toUpperCase().includes(this.search.toUpperCase()) || (item.notaFiscalAcao || '')
        .toUpperCase().includes(this.search.toUpperCase()));
    },
    ...generateComputed('ESTRUTURA', [
      'canEdit',
      'canGet',
      'canSearch',
    ]),
    ...mapGetters('implantacao', [
      'indModoVarejo',
    ]),
    ...mapGetters('roles', [
      'getUsuario',
    ]),
  },
  watch: {
  },
  data() {
    return {
      metadadoResource: this.$api.metadado(this.$resource),
      tipoContratoResource: this.$api.tipoContrato(this.$resource),
      configuracaoResource: this.$api.planejamentoContratoConfiguracao(this.$resource),
      planejamentoContratoListagemResource: this.$api.planejamentoContratoListagem(this.$resource),
      planejamentoContratoCadastroResource: this.$api.planejamentoContratoCadastro(this.$resource),
      planejamentoContratoResource: this.$api.planejamentoContratoCadastro(this.$resource),
      workflowAcaoResource: this.$api.workflowAcao(this.$resource),
      planejamentoAcaoListagemResource: this.$api.planejamentoAcaoListagem(this.$resource),
      mensagemCancelar: this.$tc('message.deseja_cancelar_acao', 1),
      headers: [
        { text: 'ID', value: 'id' },
        { text: 'Tipo de Contrato', value: 'nomeTipoContrato' },
        { text: 'Tipo de ação', value: 'nomeTipoAcao' },
        { text: 'Núm. do Contrato', value: 'numeroContratoAcao' },
        { text: 'GE/Cliente', value: 'nomeFocoContrato' },
        { text: 'Customer', value: 'codNome' },
        { text: 'NF', value: 'notaFiscalAcao' },
      ],
      acaoSelecionada: {},
      tipoContrato: {},
      objetoPassoGeral: {},
      configuracao: {},
      passoCliente: {},
      selected: [],
      acoesImportadas: [],
      contratoSelecionado: null,
      search: '',
      mensagemAviso: '',
      tipoContratoSelecionado: null,
      configuracaoSelecionada: null,
      novoContrato: true,
      bloquearExportacao: false,
      modalErrosVisivel: false,
      listaErros: [],
    };
  },
  methods: {
    ...mapActions('metadados', [
      'setContratoMetadado',
      'setAcaoMetadado',
      'setProdutoMetadado',
      'setClienteMetadado',
      'setCentroCustoMetadado',
      'setDivisaoMetadado',
      'setFornecedorMetadado',
    ]),
    carregarAcoes() {
      this.planejamentoContratoListagemResource.buscarAcoesImportadas()
        .then((res) => {
          this.acoesImportadas = res.data;
        })
        .catch((err) => {
          this.$toast(err.data.error);
        });
    },
    visualizarContrato(item) {
      Promise.all([
        this.configuracaoResource.buscarConfigVigente({ idTipoContrato: item.idTipoContrato }),
        this.planejamentoContratoCadastroResource.buscarVisualizacaoPreAcao({ idPreCadastro: item.id }),
      ])
        .then(([resConfig, resAcao]) => {
          this.configuracaoSelecionada = new ContratoConfiguracao(resConfig.data);
          const acao = resAcao.data.passoComportamento.acoes[0];
          acao.idAcaoTipo = item.idTipoAcao;
          acao.nomeTipoAcao = item.nomeTipoAcao;
          this.tipoContratoSelecionado = item.nomeTipoAcao;
          this.novoContrato = resAcao.data.id === null;
          this.objetoPassoGeral = resAcao.data.passoGeral;
          if (item.focoAcao === 'Cliente') {
            this.objetoPassoGeral.cliente = {
              codNome: item.codNomeContrato,
              id: item.idClienteContrato,
              nome: item.nomClienteContrato,
            };
          } else {
            this.objetoPassoGeral.holding = {
              idExterno: item.idExterno,
              id: item.idGrupoEconomico,
              nomExtensao: item.nomExtensao,
            };
          }
          this.$nextTick(() => {
            this.$refs.modalAcao.abreForm(acao);
          });
        })
        .catch((err) => {
          this.$error(`Erro ao buscar visualizaçao ação: ${err.data.error}`);
        });
    },
    confirmarExclusaoTodos() {
      this.mensagemAviso = 'Esta ação vai excluir TODOS os registros. Deseja confirmar?';
      this.$refs.confirmaExcluirTudo.open();
    },
    confirmaExcluirAcoesSelecionadas() {
      this.mensagemAviso = 'Esta ação vai excluir os registros selecionados. Deseja confirmar?';
      this.$refs.confirmaExcluirSelecionados.open();
    },
    confirmaCriacaoAcoesSelecionadas() {
      this.mensagemAviso = 'Esta ação vai criar os registros selecionados. Deseja confirmar?';
      this.$refs.confirmaCriarSelecionados.open();
    },
    confirmaCriarTudo() {
      this.mensagemAviso = 'Esta ação vai criar TODOS os registros. Deseja confirmar?';
      this.$refs.confirmaCriarTudo.open();
    },
    excluirTudo() {
      this.planejamentoContratoCadastroResource.deletarContratoPreCadastrado()
        .then(() => {
          this.selected = [];
          this.carregarAcoes();
          this.$toast('Ações excluídas com sucesso!');
        }).catch((err) => {
          this.$error(`Erro ao excluir ações: ${err.data.error}`);
        });
    },
    excluirSelecionados() {
      const selecionados = this.selected.map((s) => s.id);
      this.planejamentoContratoCadastroResource.deletarContratoPreCadastrado(selecionados)
        .then(() => {
          this.selected = [];
          this.carregarAcoes();
          this.$toast('Ações excluídas com sucesso!');
        }).catch((err) => {
          this.$error(`Erro ao excluir ações: ${err.data.error}`);
        });
    },
    criarTudo() {
      this.planejamentoContratoCadastroResource.concluirContratoPreCadastro()
        .then(() => {
          this.selected = [];
          this.carregarAcoes();
          this.$toast('Ações criadas com sucesso!');
        }).catch((err) => {
          const errosArray = JSON.parse(err.bodyText);
          this.listaErros = this.processarErros(errosArray);
          this.modalErrosVisivel = true;
        });
    },
    criarSelecionados() {
      const selecionados = this.selected.map((s) => s.id);
      this.planejamentoContratoCadastroResource.concluirContratoPreCadastro(selecionados)
        .then(() => {
          this.selected = [];
          this.carregarAcoes();
          this.$toast('Ações criadas com sucesso!');
        }).catch((err) => {
          const errosArray = JSON.parse(err.bodyText);
          this.listaErros = this.processarErros(errosArray);
          this.modalErrosVisivel = true;
        });
    },
    exportarLayout() {
      this.bloquearExportacao = true;
      exportacao.exportar(() => {
        this.bloquearExportacao = false;
      }, 'layout_contrato_tinting', this);
    },
    processarErros(erros) {
      return erros.map((erroStr) => {
        const erroObj = JSON.parse(erroStr);
        return {
          id: erroObj.id,
          mensagem: errorMessage({ error: erroObj.mensagem }, this.$i18n.locale),
        };
      });
    },
  },
  beforeMount() {
    this.setCentroCustoMetadado({
      resource: this.metadadoResource.definicaoCentroCusto,
    });
    this.setClienteMetadado({
      resource: this.metadadoResource.listarCliente,
    });
    this.setProdutoMetadado({
      resource: this.metadadoResource.listarProduto,
    });
    this.setDivisaoMetadado({
      resource: this.metadadoResource.listarDivisao,
    });
    this.setContratoMetadado({
      resource: this.metadadoResource.definicaoContrato,
    });
    this.setAcaoMetadado({
      resource: this.metadadoResource.definicaoAcao,
    });
    this.setFornecedorMetadado({
      resource: this.metadadoResource.listarFornecedor,
    });
  },
  mounted() {
    this.carregarAcoes();
  },
};
</script>
<style>
  .TableRow--disabled {
    color: rgba(0, 0, 0, 0.3);
  }

  .tooltip-tabela-custom {
    background: white;
    color: black;
    border-radius: 6px;
    padding: 4px;
  }

  .tabela-tooltip {
    border-collapse: collapse;
    font-size: 13px;
  }

  .tabela-tooltip th, .tabela-tooltip td {
    border: 1px solid #888;
    padding: 4px 8px;
    text-align: left;
  }
</style>
